import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { StyledSubMenuContent, StyledSubMenuList } from './Sidebar.styles';
export const subMenuTransitionDuration = 300;
let timer;
const SubMenuContent = React.forwardRef(({ children, open, ...restProps }, ref) => {
    const subMenuContentRef = ref;
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        clearTimeout(Number(timer));
        if (mounted) {
            const target = subMenuContentRef?.current;
            if (open) {
                if (target) {
                    target.style.display = 'block';
                    target.style.overflow = 'hidden';
                    target.style.height = 'auto';
                    const height = target.offsetHeight;
                    target.style.height = '0';
                    target.offsetHeight;
                    target.style.height = `${height}px`;
                    timer = setTimeout(() => {
                        target.style.overflow = 'auto';
                        target.style.height = 'auto';
                    }, subMenuTransitionDuration);
                }
            }
            else {
                if (target) {
                    target.style.overflow = 'hidden';
                    target.style.height = `${target.offsetHeight}px`;
                    target.offsetHeight;
                    target.style.height = '0';
                    timer = setTimeout(() => {
                        target.style.overflow = 'auto';
                        target.style.display = 'none';
                    }, subMenuTransitionDuration);
                }
            }
        }
        return () => clearTimeout(Number(timer));
    }, [open, mounted]);
    useEffect(() => {
        setMounted(true);
    }, []);
    return (_jsx(StyledSubMenuContent, { ref: ref, open: open, ...restProps, children: _jsx(StyledSubMenuList, { children: children }) }));
});
SubMenuContent.displayName = 'SubMenuContent';
export default SubMenuContent;
